import React, { FC, PropsWithChildren, useEffect } from 'react'
import http from '../../services/http-common'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-hot-toast'
import { useAuth } from '../../contexts/AuthContext'

const ErrorHandlingInterceptor: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate()
  const { fetchSession } = useAuth()

  useEffect(() => {
    const authInterceptor = async (error: any) => {
      const data = error.response?.data
      if (error.code === 'ERR_NETWORK') {
        throw error
      } else if (error.response?.status === 401) {
        fetchSession()
      } else if (error.response?.status === 404) {
        toast.error(data?.message)
      } else if (error.response?.status === 403) {
        // navigate('/not-authorized')
        toast.error('Not authorized!')
      } else if (error.response?.status === 500) {
        toast.error('Server error occurred!')
      } else {
        toast.error('Something went wrong!')
      }
      throw error
    }

    const interceptor = http.interceptors.response.use(async (response) => response, authInterceptor)

    return () => {
      http.interceptors.response.eject(interceptor)
    }
  }, [navigate, fetchSession])

  return <>{children}</>
}

export default ErrorHandlingInterceptor
